import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgGojek = function SvgGojek(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: 35,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.63 13.866A9.372 9.372 0 0 0 8 17.29c.001.424.028.845.082 1.266.122.957.387 1.87.79 2.74a9.19 9.19 0 0 0 1.938 2.74 9.103 9.103 0 0 0 2.675 1.814c.33.147.674.188 1.027.114 1.071-.224 1.65-1.453 1.164-2.462a1.733 1.733 0 0 0-.904-.859 5.4 5.4 0 0 1-1.679-1.148 5.81 5.81 0 0 1-1.694-3.503 5.85 5.85 0 0 1 .096-1.986 5.788 5.788 0 0 1 1.6-2.915 5.476 5.476 0 0 1 3.459-1.605 5.31 5.31 0 0 1 1.718.131c2.003.482 3.595 2.046 4.155 4.09.163.594.23 1.2.204 1.817a5.804 5.804 0 0 1-.965 3.038 5.667 5.667 0 0 1-2.413 2.07c-.066.03-.132.06-.197.095-.852.452-1.192 1.583-.643 2.474a1.647 1.647 0 0 0 2.084.655 9.012 9.012 0 0 0 1.77-1.032 9.119 9.119 0 0 0 2.714-3.229c.837-1.656 1.15-3.42.97-5.278a9.34 9.34 0 0 0-.906-3.194 9.177 9.177 0 0 0-1.684-2.402 8.957 8.957 0 0 0-2.969-2.036 8.683 8.683 0 0 0-3.14-.681 8.847 8.847 0 0 0-1.597.1 8.635 8.635 0 0 0-2.492.78 8.97 8.97 0 0 0-2.54 1.853 9.262 9.262 0 0 0-1.994 3.13Zm11.685 3.544c.023-1.915-1.493-3.513-3.313-3.491-1.731-.03-3.306 1.447-3.318 3.418-.011 1.93 1.473 3.483 3.312 3.485 1.814.002 3.297-1.542 3.32-3.412Z",
      fill: "currentColor"
    }))
  }));
};
export default SvgGojek;